import { store } from '@wajeez-web/stores/base';
import { handleDispatchResult } from '@wajeez-web/core/utils';
import { Server } from '@wajeez-web/core/api-base';

import {
  getCollectionComponentTypeByIdMultilingualAsync,
  createCollectionComponentTypeMultilingualAsync,
  editCollectionComponentTypeMultilingualAsync,
} from './slices';

export const getCollectionComponentTypeByIdMultilingual = async (
  id: number,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(
    getCollectionComponentTypeByIdMultilingualAsync(id)
  );

  return handleDispatchResult(res, onSuccess);
};

export const createCollectionComponentTypeMultilingual = async (
  data: Server.CreateCollectionComponentTypeV2Input,
  onSuccess?: (id: number) => void | Promise<void>
) => {
  const res = await store.dispatch(
    createCollectionComponentTypeMultilingualAsync(data)
  );

  return handleDispatchResult(res, onSuccess);
};

export const editCollectionComponentTypeMultilingual = async (
  data: Server.UpdateCollectionComponentTypeInput,
  onSuccess?: (id: number) => void | Promise<void>
) => {
  const res = await store.dispatch(
    editCollectionComponentTypeMultilingualAsync(data)
  );

  return handleDispatchResult(res, onSuccess);
};
